import moment from "moment-timezone";

export const Timezone = moment.tz.guess();

const DateToday = moment.tz(new Date(), Timezone);
export const Today = [DateToday, DateToday.format("YYYY-MM-DD")];

export const getToday = (timezone) => {
  const today = moment.tz(new Date(), timezone);
  return timezone ? [today, today.format("YYYY-MM-DD")] : Today;
};
export const format = (date, format, timezone = Timezone) => {
  return moment.tz(date, timezone).format(format);
};
